import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const NotFound = {
  template: '<div> Page not found! </div>'
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/activity/:activityId',
    name: 'Activity',
    component: () => import('../views/Activity.vue')
    // props: true
  },
  {
    path: '*',
    name: '404',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  saveScrollPosition: true,
  routes
})

export default router
